import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const Value = styled.h2`
  margin: 0 0 10px;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
  text-align: left;
  color: rgb(102, 102, 102);
  font-family: aria;
`;

export const Span = styled.span`
  text-align: left;
  line-height: 1.2;
  color: rgb(102, 102, 102);
  font-size: 14px;
  font-weight: 500;
  font-family: aria;
`;

export const Strong = styled.strong`
  font-weight: 800;
  font-family: aria;
`;
